module.exports = __webpack_public_path__ + "static/media/meals.4127b13b.png";